export default function Heading(props) {
  return (
    <div className={"py-5 pb-2 lg:py-10 lg:pb-5 " + props.className}>
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2
          className={
            "font-bold tracking-tight dark:text-white text-black text-4xl sm:text-5xl lg:text-6xl " +
            props.size
          }
        >
          {props.heading}
        </h2>
      </div>
    </div>
  );
}
